import React, { forwardRef, useImperativeHandle, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Input, InputNumber, Modal, Row, Divider, Space } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@/icons';
import styles from './index.module.less'
import { addCorpTag, updateCorpTag, deleteCorpTag } from '@/api/customer';

const TagFormModal = forwardRef(({
    reloadGroups
}, ref) => {
    const formRef = useRef();
    const [visible, setVisible] = useState(false);
    const [groupInfo, setGroupInfo] = useState(null);

    function showModal(groupInfo) {
        if (groupInfo) {
            setGroupInfo(groupInfo);
        }
        else {
            setGroupInfo(null);
        }
        setVisible(true);
    }

    function closeModal() {
        setVisible(false);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    function isAdd() {
        return (groupInfo == null || groupInfo == '');
    }

    function onOk() {
        formRef.current.submit();
    }

    function delCorpTag() {
        let params = {
            group_id: [groupInfo.id],
            tag_id: []
        }
        Modal.confirm({
            title: '警告',
            content: `刪除标签组会同步删除组内所有标签，确定删除标签组「${groupInfo.groupName}」`,
            okButtonProps: { danger: true },
            onOk: () => {
                deleteCorpTag(params).then(data => {
                    if (data.data.errcode == 0) {
                        reloadGroups();
                        closeModal();
                    } else {
                        Modal.warn({
                            title: '警告',
                            content: data.data.errmsg,
                        });
                    }
                });
            },
        });
    }

    function onFinish(values) {
        console.log('Received values of form: ', values);
        if (values.tags == undefined || values.tags.length == 0) {
            Modal.warn({
                title: '警告',
                content: '标签组不能为空，请添加标签',
            });
            return;
        }

        let tagList = values.tags;
        let hash = {};
        for (let i in tagList) {
            if (hash[tagList[i].tagName]) {
                Modal.warn({
                    title: '警告',
                    content: `标签「${tagList[i].tagName}」已存在`,
                });
                return;
            } else {
                hash[tagList[i].tagName] = true;
            }
        }
        let tagParams = [];
        for (let i = 0; i < tagList.length; i++) {
            let tag = {
                id: tagList[i].tagId,
                name: tagList[i].tagName
            }
            tagParams.push(tag);
        }
        let params = {
            group_id: values.groupId,
            group_name: values.groupName,
            tag: tagParams
        };
        const promise = isAdd() ? addCorpTag : updateCorpTag;
        promise(params)
            .then(data => {
                if (data.data.errcode == 0) {
                    reloadGroups();
                    closeModal();
                } else {
                    Modal.warn({
                        title: '警告',
                        content: data.data.errmsg,
                    });
                }
            })
            .catch(e => {
                e.catch422Error && e.catch422Error(formRef.current);
            });
    }

    const footer = [
        <div key="del" style={{ display: 'inline-block', marginRight: 280 }}>
            {
                isAdd() ? null : (<a style={{ color: '#f00' }} onClick={delCorpTag}>删除标签组</a>)
            }
        </div>,
        <Button key="cancelBtn" onClick={closeModal}>
            取消
        </Button>,
        <Button key="okBtn" type="primary" onClick={onOk}>
            确定
        </Button>,
    ];

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            visible={visible}
            title={isAdd() ? '新建标签组' : '编辑标签组'}
            onCancel={closeModal}
            footer={footer}
        >
            <Form ref={formRef} onFinish={onFinish} layout="vertical" initialValues={groupInfo}>
                <Form.Item hidden name="groupId">
                    <Input />
                </Form.Item>
                <Row gutter={8}>
                    <Col flex={1} style={{ marginRight: 26 }}>
                        <Form.Item
                            name="groupName"
                            label="标签组名称"
                            rules={[{ required: true, max: 30 }]}
                        >
                            <Input placeholder="标签组名称" autoFocus />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Form.Item>
                    <div>标签</div>
                </Form.Item>

                <Form.List name="tags" initialValue={isAdd() ? '' : groupInfo.tagList}>
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, fieldKey, ...restField }) => (
                                <Row gutter={8} key={key}>
                                    <Col flex={1}>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'tagName']}
                                            fieldKey={[fieldKey, 'tagName']}
                                            label="标签名称"
                                            rules={[{ required: true, max: 30 }]}
                                        >
                                            <Input placeholder="标签名称" />
                                        </Form.Item>
                                    </Col>

                                    <MinusCircleOutlined className={styles.delBtn} onClick={() => {
                                        if (!isAdd()) {
                                            let tagList = groupInfo.tagList;
                                            let tag = tagList[name];
                                            if (tag == null) {
                                                remove(name);
                                                return;
                                            }
                                            let content = '';
                                            let params = {
                                                group_id: [],
                                                tag_id: [tag.id]
                                            }
                                            if (tagList.length > 1) {
                                                content = `确定要删除标签「${tag.tagName}」`;
                                            } else {
                                                content = `「${tag.tagName}」为该标签组下最后一个标签，删除后标签组也会被删除，确定要删除标签`;
                                                params.group_id.push(groupInfo.id);
                                            }
                                            Modal.confirm({
                                                title: '警告',
                                                content: content,
                                                okButtonProps: { danger: true },
                                                onOk: () => {
                                                    deleteCorpTag(params).then(data => {
                                                        if (data.data.errcode == 0) {
                                                            reloadGroups();
                                                            closeModal();
                                                        } else {
                                                            Modal.warn({
                                                                title: '警告',
                                                                content: data.data.errmsg,
                                                            });
                                                        }
                                                    });
                                                },
                                            });
                                        }
                                        else {
                                            remove(name);
                                        }
                                    }} />
                                </Row>
                            ))}
                            <Row gutter={8}>
                                <Col flex={1} style={{ marginRight: 26 }}>
                                    <Form.Item>
                                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                            添加标签
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>

                        </>
                    )}
                </Form.List>

                <Form.Item style={{ display: 'none' }}>
                    <Button type="primary" htmlType="submit" />
                </Form.Item>
            </Form>
        </Modal>
    );

});


TagFormModal.displayName = 'TagFormModal';

TagFormModal.propTypes = {
    groupInfo: PropTypes.object,
    reloadGroups: PropTypes.func,
};

export default TagFormModal;
